import { render, staticRenderFns } from "./PointsBalanceLocksTable.vue?vue&type=template&id=2ce14517&scoped=true"
import script from "./PointsBalanceLocksTable.vue?vue&type=script&lang=js"
export * from "./PointsBalanceLocksTable.vue?vue&type=script&lang=js"
import style0 from "./PointsBalanceLocksTable.vue?vue&type=style&index=0&id=2ce14517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce14517",
  null
  
)

export default component.exports